<div class="modal-header">
  <button type="button" class="close" ng-click="cancel()">&times;</button>
  <h3 class="modal-title">Configurações</h3>
</div>
<div class="modal-body">
  <form name="form">
    <div class="form-group">
      <label for="widget-title" class="control-label">Título</label>
      <input type="text" class="form-control" name="widgetTitle" ng-model="result.title">
    </div>
    <div class="form-group">
      <label class="control-label">Propriedade</label>
      <ui-select ng-model="result.dataModelOptions.propriedade" theme="bootstrap" id="propriedade" name="propriedade" append-to-body="true">
        <ui-select-match placeholder="Propriedade atual ({{$root.currentPropriedade.descricao}})">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.propriedade = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="propriedade in result.data.propriedades | orderBy: 'descricao' | filter: $select.search track by propriedade.id">
          <span class="form-group" ng-bind-html="propriedade.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">
        Talhão
        <span ng-show="$root.globalGleba && !result.dataModelOptions.gleba">(usando geral - {{$root.globalGleba.descricao}})</span>
      </label>
      <ui-select ng-model="result.dataModelOptions.gleba" theme="bootstrap" id="gleba" name="gleba" append-to-body="true">
        <ui-select-match placeholder="{{$root.globalGleba ? 'Talhão atual ('+$root.globalGleba.descricao+')' : 'Selecione o talhão'}}">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.gleba = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="gleba in result.dataModelOptions.propriedade.glebas | orderBy: 'descricao' | filter: $select.search track by gleba.id">
          <span class="form-group" ng-bind-html="gleba.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">Cultura</label>
      <ui-select ng-model="result.dataModelOptions.cultura" theme="bootstrap" id="cultura" name="cultura">
        <ui-select-match placeholder="Selecione a cultura">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.cultura = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="cultura in result.data.culturas | orderBy: 'descricao' | filter: $select.search track by cultura.id">
          <span class="form-group" ng-bind-html="cultura.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">Usuário</label>
      <ui-select ng-model="result.dataModelOptions.usuario" theme="bootstrap" id="usuario" name="usuario" append-to-body="true">
        <ui-select-match placeholder="Selecione o usuário">
          {{$select.selected.descricao | capitalize}}
          <span class="clear-btn" ng-click="$event.stopPropagation(); result.dataModelOptions.usuario = null"><i class="fa fa-remove true-clear-icon"></i></span>
        </ui-select-match>
        <ui-select-choices repeat="usuario in result.data.usuarios | orderBy: 'descricao' | filter: $select.search track by usuario.id">
          <span class="form-group" ng-bind-html="usuario.descricao | capitalize | highlight: $select.search"></span>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="row">
      <div class="form-group col-xs-6">
        <label for="interval-after" class="control-label">Intervalo Anterior</label>
        <input type="number" name="interval-before" id="interval-before" class="form-control" ng-model="result.dataModelOptions.intervalBefore" required>
      </div>
      <div class="form-group col-xs-6">
        <label for="interval-after" class="control-label">Intervalo Posterior</label>
        <input type="number" name="interval-after" id="interval-after" class="form-control" ng-model="result.dataModelOptions.intervalAfter" required>
      </div>
    </div>
    <div class="form-group">
      <label for="tipos" class="control-label">Tipo</label>
      <ui-select multiple close-on-select="false" ng-model="result.dataModelOptions.tipos" theme="bootstrap" name="tipos" id="tipos" append-to-body="true">
        <ui-select-match placeholder="Selecione os tipos">
          {{$item.descricao}}
        </ui-select-match>
        <ui-select-choices repeat="tipo in result.data.tipos | orderBy: 'descricao' | filter: $select.seach track by tipo.id">
          <div ng-bind-html="tipo.descricao | highlight: $select.search"></div>
        </ui-select-choices>
      </ui-select>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-default" ng-click="cancel()">Cancelar</button>
  <button type="button" class="btn btn-primary" ng-click="ok()">OK</button>
</div>
